module.exports = __webpack_public_path__ + "files/04ac0e4c01539cc87f43d51ac622ac20.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/monokai.png
// module id = 646
// module chunks = 27